// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ButtonGroup Layout */
.button-group {
  display: flex;
  align-items: center;
  gap: 0;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: var(--shadow-sm);
}

/* Base button styles */
.button-group-button {
  border: none;
  outline: none;
  cursor: pointer;
  padding: 8px 16px;
  min-width: 80px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Active (selected) button state */
.button-group-button-active {
  background-color: var(--accent);
  color: var(--text-on-accent);
}

/* Inactive (unselected) button state */
.button-group-button-inactive {
  background-color: var(--color-light-gray);
  color: var(--color-black);
}

/* Rounded corners for first and last buttons */
.button-group-button-first {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.button-group-button-last {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

/* Hover effects */
.button-group-button-active:hover {
  background-color: var(--color-dark-green);
}

.button-group-button-inactive:hover {
  background-color: var(--color-light-gray);
}



/* Mobile responsive styles */
@media (max-width: 768px) {
  .button-group-button {
    min-width: 70px;
    padding: 6px 12px;
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .button-group-button {
    min-width: 60px;
    padding: 5px 10px;
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Button/ButtonGroup.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,uBAAuB;AACvB;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,mCAAmC;AACnC;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA,uCAAuC;AACvC;EACE,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA,+CAA+C;AAC/C;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA,kBAAkB;AAClB;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;;;AAIA,6BAA6B;AAC7B;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,eAAe;EACjB;AACF","sourcesContent":["/* ButtonGroup Layout */\n.button-group {\n  display: flex;\n  align-items: center;\n  gap: 0;\n  border-radius: 4px;\n  overflow: hidden;\n  box-shadow: var(--shadow-sm);\n}\n\n/* Base button styles */\n.button-group-button {\n  border: none;\n  outline: none;\n  cursor: pointer;\n  padding: 8px 16px;\n  min-width: 80px;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Active (selected) button state */\n.button-group-button-active {\n  background-color: var(--accent);\n  color: var(--text-on-accent);\n}\n\n/* Inactive (unselected) button state */\n.button-group-button-inactive {\n  background-color: var(--color-light-gray);\n  color: var(--color-black);\n}\n\n/* Rounded corners for first and last buttons */\n.button-group-button-first {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n\n.button-group-button-last {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n\n/* Hover effects */\n.button-group-button-active:hover {\n  background-color: var(--color-dark-green);\n}\n\n.button-group-button-inactive:hover {\n  background-color: var(--color-light-gray);\n}\n\n\n\n/* Mobile responsive styles */\n@media (max-width: 768px) {\n  .button-group-button {\n    min-width: 70px;\n    padding: 6px 12px;\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 480px) {\n  .button-group-button {\n    min-width: 60px;\n    padding: 5px 10px;\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
